import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { CompanyResponse, CompanyRoleResponse, NewDateDteRequest, PasswordSATRequest } from 'src/app/models/company.model';
import { PaginationModel, SimplePaginationModel } from 'src/app/models/pagination.model';
import { AuthenticationService } from '../../authentication/authentication/authentication.service';
import { CompanyService } from 'src/app/services/company.service';
import { ResponseObject } from 'src/app/models/response-object.model';
import { HttpErrorResponse } from '@angular/common/http';
import { InputAutocompleteModel } from 'src/app/models/input-autocomplete.model';
import { ButtonLoading } from 'src/app/models/button-loading.model';
import { UserSaved } from 'src/app/models/user.model';

@Component({
  selector: 'app-date-dte',
  templateUrl: './date-dte.component.html',
  styleUrls: ['./date-dte.component.scss']
})
export class DateDteComponent implements OnInit {
  failedStart = false;
  passwords: PaginationModel = new PaginationModel(0, 5, 0, 0, [{ id: 123, nit: "123", name: "Empresa", password: 'pass' }], []);
  companies: CompanyRoleResponse[] = [];
  allCompanies: CompanyRoleResponse[] = [];
  companiesDateDte: CompanyResponse[] = [];
  totalCompaniesDateDte: number = 0;
  pagination: SimplePaginationModel = new SimplePaginationModel(0, 6, 0, 0, 0);
  sizes = [6, 12, 36, 60];
  filterWord = "";
  user: UserSaved = null;
  selected = null;
  newPassword = "";
  inputs = new InputAutocompleteModel("", false, true, "", "fa-asterisk", "", "", null, []);
  timeout = null;
  buttonSave = new ButtonLoading("btn-success", false, "GUARDAR", "fa-save");
  modalCreate = false;
  edit: CompanyResponse = null;

  constructor(
    private toastService: ToastrService,
    private authService: AuthenticationService,
    private companyService: CompanyService
  ) {

  }


  getAssociatedCompanies() {
    this.companyService.getCompaniesAssociatedToPartner(this.user.id).subscribe({
      next: (response: ResponseObject) => {
        this.companies = response.data;
        this.allCompanies = this.companies;
      },
      error: (error: HttpErrorResponse) => {
        this.toastService.error("Error al obtener las companias asociadas");
      }
    })
  }

  filterCompany() {
    clearTimeout(this.timeout);
    this.timeout = setTimeout(() => {
      this.pagination.page = 0;
      this.getPaginationCompaniesDateDte();
    }, 300);
  }

  ngOnInit(): void {
    this.user = JSON.parse(this.authService.getCurrentUser());
    this.companies = Object.assign(this.companies, this.user.companyRoles);
    this.allCompanies = this.companies;
    this.getPaginationCompaniesDateDte();
    if (this.user.contadorGT) {
      this.getAssociatedCompanies();
    }
  }

  getPaginationCompaniesDateDte() {
    this.companyService.getPaginationCompaiesDateDte(
      this.filterWord,
      this.pagination.page,
      this.pagination.size,
      this.user.id,
      this.user.contadorGT
    ).subscribe({
      next: (response: ResponseObject) => {
        var res = response.data as { total: number, companies: CompanyResponse[] }
        this.totalCompaniesDateDte = res.total;
        this.companiesDateDte = res.companies;
        this.pagination.total = this.totalCompaniesDateDte;
        this.pagination.start = this.pagination.page * this.pagination.size + 1;
        this.pagination.end = this.pagination.page * this.pagination.size + res.companies.length;        
      },
      error: (error: HttpErrorResponse) => {
        console.log(error);
      }
    })
  }

  saveDateDte(company) {    
    var request = new NewDateDteRequest();
    request.idCompany = company.id;
    request.dateDte = new Date(company.dateDte);
    
    this.companyService.saveDateDte(request, this.user.contadorGT).subscribe({
      next: (response: ResponseObject) => {
        this.toastService.success("Fecha guardada correctamente!");        
      },
      error: (error: HttpErrorResponse) => {
        this.toastService.error(error.error.message);
      }
    })
  }

  copy(copyText) {
    const selBox = document.createElement('textarea');
    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    selBox.value = copyText;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);
    this.toastService.success("Contraseña pegada al portapapeles!");
  }

}
